import { Box, Button, Checkbox, FormControl, FormControlLabel, IconClassKey, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { Component } from "react";
import { ConditionalStyles, TableColumn } from "react-data-table-component";
import DataGrid from "../../Components/DataGrid/DataGrid";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import FormServices from "../../Services/FormServices";
import { IPopoverItemData } from "../../Components/DataGrid/Plugins/CustomMaterialMenu/Interface";
import CustomMaterialMenu from "../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";
import { ShowBlocker } from "../../Components/LoaderComponent/LoaderComponent";
import ProfileServices from "../../Services/ProfileServices";
import { ShowAlert } from "../../Components/ShowAlert";
import IconButton from '@mui/material/IconButton';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import AttachmentIcon from '@mui/icons-material/Attachment';
import './KwongClaim.css';
import { amountFormat } from "../../Components/helper";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx-js-style';

export interface IClaim {
    userId: string,
    taxYear: number,
    returnFilingDate: string,
    filingStatus: string,
    totalClaim: number,
    netFtp: number,
    netFtf: number,
    netInterest: number,
    net6654: number,
    ftpClaim: number,
    ftfClaim: number,
    interestClaim: number,
    claim6654: number,
    isReviewRequired: number,
    isReviewApproved: number,
    htmlTranscript: string
}

export interface IAuthorizedUser {
    userId: string,
    userName: string,
    email: string,
    claims: IClaim[],
    phoneNumber: string,
    paymentStatus: string,
    isReviewRequired: string,
    totalClaim: number | string,
    createdUtc: string,
    status: string,
    isImportedUser: number
}

interface IAuthorizedUserState {
    subList: IAuthorizedUser[]
    accessToken: string,
    currentPage: number,
    currentRowsPerPage: number,
    searchText: string,
    totalRows: 0,
    currentSortColumn: string,
    sortingDirection: string,
    subject: string,
    body: string,
    claimStatus: string,
    reviewReq: string,
    resultsViewed: string,
    selectedRows: any[],
    isManualUpload: boolean,
    sendInstruction: boolean,
    showsendInstruction: boolean,
    clearSelectedRows?: boolean;
}

interface IClaimProps {
    claims: IClaim[];
    accessToken: string;
    refreshCallBack: () => void;
}

class PaymentTable extends Component<IClaimProps, {}> {
    constructor(props: IClaimProps) {
        super(props);
    }

    // Format the Amount values
    formatAmount = (value: any) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const num = Number(value);

        if (isNaN(num)) {
            return value;
        }
        // Return $0 if the value is empty
        if (num === 0) {
            return '$0';
        }
        // Display the decimal value with 2 decimal points
        return `$${num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    private kwongClaimColumns: TableColumn<IClaim>[] = [
        { name: 'Tax Year', selector: row => row.taxYear, },
        { name: 'Filing Status', selector: row => row.filingStatus, },
        { name: 'Net FTP', selector: row => this.formatAmount(row.netFtp) },
        { name: 'Net FTF', selector: row => this.formatAmount(row.netFtf) },
        { name: 'Net Interest', selector: row => this.formatAmount(row.netInterest) },
        { name: 'Net 6654', selector: row => this.formatAmount(row.net6654) },
        { name: 'FTP Claim', selector: row => this.formatAmount(row.ftpClaim) },
        { name: 'FTF Claim', selector: row => this.formatAmount(row.ftfClaim) },
        { name: 'Interest Claim', selector: row => this.formatAmount(row.interestClaim) },
        { name: 'Claim 6654', selector: row => this.formatAmount(row.claim6654) },
        { name: 'Total Claim', selector: row => this.formatAmount(row.totalClaim) },
        {
            cell: (row) => {
                let menu: IPopoverItemData[] = [];
                if (row.isReviewRequired === 1 && !(row.isReviewApproved === 1)) {
                    menu.push(
                        {
                            key: "approve",
                            label: "Approve"
                        }
                    )
                }

                // Hide the approve menu if there are no items
                if (menu.length === 0) {
                    return null;
                }

                return <CustomMaterialMenu
                    fontSize="small"
                    multiPopoverItems={menu}
                    onPopoverClick={(key_: string, label_: string) => {

                        if (key_ == "approve") {
                            this.handleStatusUpdate(row);
                        }
                    }}
                />
            },
            allowOverflow: true,
            button: true,
            width: '56px'
        }
    ];

    // conditionalRowStyles: ConditionalStyles<IClaim>[] = [
    //     {
    //         when: (row) => row.isReviewRequired === 1 && !(row.isReviewApproved === 1),
    //         style: {
    //             backgroundColor: "#ffeb3b"
    //         },
    //     },
    // ];

    openHtmlAsPdf = (htmlString: string, taxYear: number) => {
        const element = document.createElement('div');
        element.innerHTML = htmlString;

        const options = {
            margin: 10,
            filename: `transcript_${taxYear}.pdf`,
            image: { type: 'jpeg' as const, quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm' as const, format: 'a4' as const, orientation: 'portrait' as const }
        };

        html2pdf()
            .set(options)
            .from(element)
            .outputPdf('bloburl')
            .then((pdfUrl: any) => {
                window.open(pdfUrl, '_blank');
            });
    };

    handleStatusUpdate(row: IClaim) {

        Swal.fire({
            title: `Approve Kwong Payment`,
            html: `
                <div style="text-align: left;">
                    <p>Are you sure you want to <strong>Approve</strong> the kwong payment for the tax year - ${row.taxYear}</p>                    
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Approve',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateKwongPaymentReviewStatus(row.userId, row.taxYear);
            }
        });
    }

    updateKwongPaymentReviewStatus(userId: string, taxYear: number) {
        const requestData = {
            userId: userId,
            taxYear: taxYear
        };

        ShowBlocker(true);

        FormServices.updateKwongPaymentReviewStatus(requestData, this.props.accessToken).then(r => {
            ShowBlocker(false);
            if (r.ok) {
                r.json().then(response => {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Kwong payment has been Approved successfully.`,
                    }).then(() => {
                        // Refresh the data after successful update
                        //this.props.refreshCallBack();
                        window.location.reload();
                    });
                })
            }
        });
    }


    render() {
        return (
            <>
                {/* Title */}
                <Typography
                    component="p"
                    sx={{
                        fontWeight: 600,
                        color: "text.primary",
                    }}
                >
                    Payment Details
                </Typography>
                <DataGrid
                    // title='Payment Details'
                    columns={this.kwongClaimColumns}
                    data={this.props.claims}
                    // pagination
                    // paginationTotalRows={this.props.claims?.length}
                    // conditionalRowStyles={this.conditionalRowStyles}
                    customStyles={customStylesClaimTable}
                />
            </>
        );
    }
}

const customStylesClaimTable = {
    table: {
        style: {
            border: '1px solid #E5E7EB',
            overflow: 'hidden',
        },
    },
    headRow: {
        style: {
            fontWeight: 600,
        },
    },
};

const customStyles = {
    table: {
        style: {
            border: '1px solid #E5E7EB',
            borderRadius: '12px',
            overflow: 'hidden',
        },
    },

    headRow: {
        style: {
            backgroundColor: '#F3F4F6',
            minHeight: '60px',
            borderBottom: '1px solid #E5E7EB',
        },
    },

    headCells: {
        style: {
            fontSize: '14px',
            fontWeight: 600,
            color: '#374151',
            paddingLeft: '16px',
            paddingRight: '16px',
            whiteSpace: 'normal',
            lineHeight: '20px',
        },
    },

    rows: {
        style: {
            minHeight: '72px',
            fontSize: '14px',
            color: '#111827',
            borderBottom: '1px solid #F1F5F9',
        },
        highlightOnHoverStyle: {
            backgroundColor: '#F3F4F6',
            transitionDuration: '0.15s',
            transitionProperty: 'background-color',
        },
    },

    cells: {
        style: {
            paddingLeft: '16px',
            paddingRight: '16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '22px',
        },
    },
};

const getStatusClass = (status: string) => {
    switch (status) {
        case 'Completed':
            return 'completed';

        case 'IRS Approved':
            return 'approved';

        case '8821 Signature Pending':
        case 'IDV Pending':
        case 'Ready for IRS Submission':
            return 'pending';

        default:
            return 'default';
    }
};



class KwongClaimManagement extends Component<{}, IAuthorizedUserState> {

    constructor(_props: any) {
        super(_props);
        this.state = {
            subList: [],
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            currentSortColumn: '',
            sortingDirection: '',
            body: '',
            subject: '',
            claimStatus: 'all',
            reviewReq: 'all',
            resultsViewed: 'all',
            selectedRows: [],
            isManualUpload: false,
            sendInstruction: false,
            showsendInstruction: false
        }
    }

    private formColumns: TableColumn<IAuthorizedUser>[] = [

        {
            name: 'Date',
            selector: (row: IAuthorizedUser) => this.formattedDate(row.createdUtc),
            width: '120px',
        },
        {
            name: 'Taxpayer Name',
            width: '240px',
            cell: row => (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontWeight: '500',
                        }}
                    >
                        {row.userName}
                    </div>

                    <div
                        style={{
                            fontSize: '12px',
                            color: '#666',
                            wordBreak: 'break-word',
                            lineHeight: '16px',
                        }}
                    >
                        {row.email}
                    </div>
                </div>
            ),
            sortable: true,
        },

        {
            name: 'Phone',
            selector: (row: IAuthorizedUser) => row.phoneNumber,
            sortable: false,
            width: '150px',
        },
        {
            name: 'Status',
            selector: (row: IAuthorizedUser) => row.status,
            sortable: false,
            cell: (row: IAuthorizedUser) => (
                <div className={`status-badge ${getStatusClass(row.status)}`}>
                    {row.status}
                </div>
            ),
            width: '160px'
        },
        {
            name: 'Claim Amount',
            selector: (row: IAuthorizedUser) => `${row.totalClaim == 'Pending' ? row.totalClaim : amountFormat(Number(row.totalClaim), 'en-US', 'USD')}`,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Pay Status',
            selector: (row: IAuthorizedUser) => `${row.paymentStatus == 'Pending' ? row.paymentStatus : amountFormat(Number(row.paymentStatus), 'en-US', 'USD')}`,
            sortable: true,
            width: '150px',
        },
        {
            name: (
                <>
                    Review <br /> Required
                </>
            ),
            // selector: (row: IAuthorizedUser) => row.isReviewRequired,
            cell: (row: IAuthorizedUser) => (
                row.isReviewRequired === 'Yes'
                    ? <CheckIcon
                        sx={{
                            color: '#00A63E',
                            fontSize: 22,
                        }}

                    />
                    : <ClearIcon
                        sx={{
                            color: '#E7000B',
                            fontSize: 22,
                        }}
                    />
            ),
        },
        {
            name:'Download 843',
            width: '140px',
            cell: (row: IAuthorizedUser) => (
                <>
                <IconButton
                    sx={{
                        color: '#2196F3',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-disabled': {
                            color: '#2196F3 !important',
                            opacity: '0.4 !important'
                        }
                    }}
                    disabled={row.claims ? false : true}
                    onClick={() => this.handleDownloadForm843(row.userId)}
                >
                    <SaveAltIcon /> <Typography component="span" style={{ paddingTop: '0.5rem' }}>843</Typography>

                </IconButton>

                    <IconButton
                        sx={{
                            color: '#2196F3',
                            '&:hover': {
                                backgroundColor: 'transparent',
                            },
                            '&.Mui-disabled': {
                                color: '#2196F3 !important',
                                opacity: '0.4 !important'
                            }
                        }}
                        disabled={row.claims ? false : true}
                        onClick={() => this.handleDownloadForm843Attachment(row.userId)}
                    >
                        <AttachmentIcon /> <Typography component="span" style={{ paddingTop: '0.5rem' }}>843</Typography>

                    </IconButton></>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
          },
        {
            name: (
                <>
                    Download <br /> Transcript
                </>
            ),
            cell: (row: IAuthorizedUser) => (
                <IconButton
                    sx={{
                        color: '#2196F3',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-disabled': {
                            color: '#2196F3 !important',
                            opacity: '0.4 !important'
                        }
                    }}
                    disabled={row.claims ? false : true}
                    onClick={() => this.handleDownloadTranscript(row.userId)}
                >
                    <SaveAltIcon /> <Typography component="span" style={{ paddingTop: '0.5rem' }}>Transcript</Typography>
                </IconButton>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '140px'
        },
        {
            name: 'Email  Contact',
            cell: (row: IAuthorizedUser) => (
                <Button
                    onClick={() => this.handleEmailReminder(row.userId, !!row.claims, row.isImportedUser)}
                    sx={{
                        textTransform: 'none',
                        color: '#FFF',
                        backgroundColor: '#2196F3',
                        px: 2,
                        '&:hover': {
                            backgroundColor: '#2196F3',
                        },
                    }}
                    startIcon={<EmailOutlinedIcon />}
                >
                    Send Reminder
                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '180px'
        }
    ];

    // Format the UTC to dd/mm/YYYY
    formattedDate(date: string) {
        const d = new Date(date);
        return String(d.getMonth() + 1).padStart(2, "0") +
            "/" +
            String(d.getDate()).padStart(2, "0") +
            "/" +
            d.getFullYear();
    }

    // conditionalRowStyles: ConditionalStyles<IAuthorizedUser>[] = [
    //     {
    //         when: (row) => row.claims.some((item) => item.isReviewRequired === 1 && !(item.isReviewApproved === 1)),
    //         style: {
    //             backgroundColor: "#ffeb3b"
    //         },
    //     },
    // ];

    // Download Transcript
    handleDownloadTranscript = async (userId?: string) => {
        let userIds: string[] = [];
        try {
            if (userId) { // Single user
                userIds = [userId];
            } else { // Bulk users
                userIds = this.state.selectedRows.map(
                    (row: any) => row.userId
                );
            }
            const payload = {
                userIds,
            };

            // API call
            this.downloadTranscriptZip(payload);

        } catch (error) {
            console.log(error);
        }
    };

    // Email Reminder
    handleEmailReminder = (userId?: string, showsendInstruction?: boolean, isImportedUser?: number) => {

        let userIds: string[] = [];
        try {

            if (userId) { // Single user
                userIds = [userId];
            } else { // Bulk users
                userIds = this.state.selectedRows.map(
                    (row: any) => row.userId
                );
                // Show checkbox only if all selected rows have claims
                showsendInstruction = this.state.selectedRows.every(
                    (row: any) => !!row.claims
                );
                // Check the user is imported or not
                isImportedUser = this.state.selectedRows.every(
                    (row: any) => row.isImportedUser === 1
                ) ? 1: 0;
            }
            const payload = {
                userIds,
            };
            // Email API call
            this.sendEmail(userIds, showsendInstruction, isImportedUser);

        } catch (error) {
            console.log(error);
        }

    };

    // Download Form843
    handleDownloadForm843 = async (userId?: string) => {
        let userIds: string[] = [];
        try {

            if (userId) { // Single user
                userIds = [userId];
            } else { // Bulk users
                userIds = this.state.selectedRows.map(
                    (row: any) => row.userId
                );
            }
            const payload = {
                userIds,
            };

            // Form 843 API call
            this.downloadForm843(payload);

        } catch (error) {
            console.log(error);
        }

    };

    // Download Form843 attachment
    handleDownloadForm843Attachment = async (userId?: string) => {
        let userIds: string[] = [];
        try {

            if (userId) { // Single user
                userIds = [userId];
            } else { // Bulk users
                userIds = this.state.selectedRows.map(
                    (row: any) => row.userId
                );
            }
            const payload = {
                userIds,
            };

            // API 843 Attachment call
            this.downloadForm843Attachment(payload);

        } catch (error) {
            console.log(error);
        }
    };

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getAllKwongClaims();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    // Format the Amount values
    formatAmount = (value: any) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const num = Number(value);

        if (isNaN(num)) {
            return value;
        }
        // Return $0 if the value is empty
        if (num === 0) {
            return '$0';
        }
        // Display the decimal value with 2 decimal points
        return `$${num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    // Download Claim Detaiils as XLSX
    handleClaimXLSXDownload = () => {

        const response = this.state.subList;
        const exportData: any[] = [];
        const merges: any[] = [];

        let rowIndex = 1; // row 0 is header

        response.forEach((user: any) => {

            const claims = user.claims?.length ? user.claims : [{}];

            const startRow = rowIndex;

            claims.forEach((claim: any) => {
                exportData.push({
                    'Date': this.formattedDate(user.createdUtc),
                    'TaxPayer Name': user.userName,
                    'Email': user.email,
                    'Phone': user.phoneNumber,
                    'Status': user.status,
                    'Claim Amount': this.formatAmount(user.totalClaim),
                    'Pay Status': this.formatAmount(user.paymentStatus),
                    'Review Required': user.isReviewRequired,

                    // Claim Table
                    'Tax Year': claim.taxYear || '',
                    'Filing Status': claim.filingStatus || '',
                    'Net FTP': this.formatAmount(claim.netFtp),
                    'Net FTF': this.formatAmount(claim.netFtf),
                    'Net Interest': this.formatAmount(claim.netInterest),
                    'Net 6654': this.formatAmount(claim.net6654),
                    'FTP Claim': this.formatAmount(claim.ftpClaim),
                    'FTF Claim': this.formatAmount(claim.ftfClaim),
                    'Interest Claim': this.formatAmount(claim.interestClaim),
                    'Claim 6654': this.formatAmount(claim.claim6654),
                    'Total Claim': this.formatAmount(claim.totalClaim) 
                });

                rowIndex++;
            });

            const endRow = rowIndex - 1;

            // merge only when more than one row exists
            if (startRow < endRow) {

                for (let col = 0; col <= 7; col++) {
                merges.push({
                    s: { r: startRow, c: col },
                    e: { r: endRow, c: col }
                });
                }
            }

        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        
        // Merge the cells which having claim
        worksheet['!merges'] = merges;

        const workbook = XLSX.utils.book_new();

        // Width for each cells
        worksheet['!cols'] = [
            { wch: 22 }, // Date
            { wch: 25 }, // Tax Payer Name
            { wch: 30 }, // Email
            { wch: 18 }, // Phone
            { wch: 25 }, // Status
            { wch: 15 }, // Claim Amount
            { wch: 15 }, // Pay Status
            { wch: 15 }, // Review Required
            { wch: 10 }, // Tax Year
            { wch: 25 }, // Filing Status
            { wch: 15 }, // Net FTP
            { wch: 15 }, // Net FTF
            { wch: 15 }, // Net Interest
            { wch: 15 }, // Net 6654
            { wch: 15 }, // FTP Claim
            { wch: 15 }, // FTF Claim
            { wch: 15 }, // Interest Claim
            { wch: 15 }, // Claim 6654
            { wch: 15 }, // Total Claim
        ];

        // Used to determine the boundaries of the workshee
        const range = XLSX.utils.decode_range(worksheet['!ref']!);

        // Numeric fields
        const amountHeaders  = ['Phone', 'Claim Amount', 'Pay Status', 'Tax Year', 'Net FTP', 'Net FTF', 'Net Interest', 'Net 6654', 'FTP Claim', 'FTF Claim', 'Interest Claim', 'Claim 6654', 'Total Claim'];

        const amountCols: string[] = [];

        // Pick the color code as per Tenant
        const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-main').trim().replace('#', '') || '4472C4';

        // Loop all rows and columns
        for (let c = range.s.c; c <= range.e.c; c++) {
            const headerCell = XLSX.utils.encode_cell({ r: 0, c });
            const header = worksheet[headerCell]?.v;

            // Header Style
            worksheet[headerCell].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" }
                },
                fill: {
                    fgColor: { rgb: primaryColor }
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center"
                },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } }
                }
            };

            if (amountHeaders.includes(header)) {
                amountCols.push(XLSX.utils.encode_col(c));
            }
        }

        Object.keys(worksheet).forEach((cell) => {
            if (cell[0] === '!') return;

            const row = Number(cell.match(/\d+/)?.[0]);

            // Skip header row
            if (row === 1) return;

            const col = cell.match(/[A-Z]+/)?.[0];

            // Align the numeric fields to right
            worksheet[cell].s = {
                ...(worksheet[cell].s || {}),
                alignment: {
                    ...(worksheet[cell].s?.alignment || {}),
                    horizontal: amountCols.includes(col!) ? 'right' : 'center',
                    vertical: 'center'
                }
            };
        });

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            'Revenue Details'
        );

        // Timestamp for file download
        const now = new Date();
        const timestamp =
            `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

        XLSX.writeFile(
            workbook,
            `Kwong_Claim_${timestamp}.xlsx`
        );
    };


    getAllKwongClaims() {
        let postData = {
            sort: {
                column: this.state.currentSortColumn,
                direction: this.state.sortingDirection
            },
            limit: this.state.currentRowsPerPage,
            offset: (this.state.currentPage - 1) * this.state.currentRowsPerPage,
            searchFilter: this.state.searchText,
            additionalFilter: {
                status: this.state.claimStatus,
                reviewRequired: this.state.reviewReq,
                isImported: this.state.isManualUpload
            }
        };
        FormServices.getAllKwongClaims(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(response => {
                    this.setState((prevState) => ({ subList: response.data, totalRows: response.totalCount, clearSelectedRows: !this.state.clearSelectedRows, }), 
                    () => {
                        this.setState({
                            selectedRows: []
                        });
                    });
                })
            }
        });
    }

    downloadTranscriptZip(payload: any) {
        FormServices.downloadTranscriptZip(payload, this.state.accessToken).then(r => {

            if (r.ok) {
                r.json().then((response) => {
                    response.data.forEach((file: string, index: number) => {

                        setTimeout(() => {

                            const link =
                                document.createElement('a');

                            link.href =
                                file;

                            document.body.appendChild(link);

                            link.click();

                            document.body.removeChild(link);

                        }, index * 1000);
                    });
                })
            }
        });
    }

    downloadForm843(payload: any) {
        FormServices.downloadForm843(payload, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then((response) => {
                    response.data.forEach((file: string, index: number) => {

                        setTimeout(() => {

                            const link =
                                document.createElement('a');

                            link.href = file;

                            document.body.appendChild(link);

                            link.click();

                            document.body.removeChild(link);

                        }, index * 1000);
                    });
                })
            }
        });
    }

    downloadForm843Attachment(payload: any) {
        FormServices.downloadForm843Attachment(payload, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then((response) => {
                    response.data.forEach((file: string, index: number) => {

                        setTimeout(() => {

                            const link =
                                document.createElement('a');

                            link.href = file;

                            document.body.appendChild(link);

                            link.click();

                            document.body.removeChild(link);

                        }, index * 1000);
                    });
                })
            }
        });
    }


    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Date":
                actualColName = 'createdUtc';
                break;
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Phone":
                actualColName = 'mobileNumber';
                break;
            case "Status":
                actualColName = 'status';
                break;
            case "Pay Status":
                actualColName = 'paymentStatus';
                break;
            case "Review Required":
                actualColName = 'isReviewRequired';
                break;
            case "Claim Amount":
                actualColName = 'totalClaim';
                break;
        }
        return actualColName;
    }

    sendEmail = async (userIds: any, showsendInstruction = false, isImportedUser = 0) => {
        const { subject, body } = this.state;
        // Email instructions only for imported users with claims
        const result = await Swal.fire({
            title: "Send Email",
            html: `
            ${ ((this.state.isManualUpload || isImportedUser == 1) && showsendInstruction) ? `
                <div style="text-align:left; margin-bottom:10px;">
                    <label>
                        <input type="checkbox" id="sendInstruction" />
                        Send Kwong Email Instruction
                    </label>
                </div>
                `: ''
            }
                <div id="emailFields">
                    <input 
                        id="swal-subject" 
                        class="swal2-input" 
                        placeholder="Enter Subject"
                        value="${subject}"
                        style="
                            width: 100%;
                            margin: 10px 0;
                            box-sizing: border-box;
                        "
                    />

                    <textarea 
                        id="swal-body" 
                        class="swal2-textarea" 
                        placeholder="Enter Email Body"
                        style="
                            width: 100%;
                            height: 150px;
                            margin: 10px 0;
                            box-sizing: border-box;
                        "
                    >${body}</textarea>
                </div>`,
            showCancelButton: true,
            confirmButtonText: "Send",

            didOpen: () => {

                const sendInstruction = document.getElementById("sendInstruction");
                const subjectInput = document.getElementById("swal-subject");
                const bodyInput = document.getElementById("swal-body");
                const emailFields = document.getElementById("emailFields") as HTMLDivElement;

                sendInstruction?.addEventListener("change", (e) => {
                    // Clear any validation message
                    Swal.resetValidationMessage();

                    const checked = (e.target as HTMLInputElement).checked;
                    this.setState({
                        sendInstruction: checked
                    });

                    // Hide/Show subject and body fields
                    // Hide when the Email instruction field is checked
                    emailFields.style.display = checked ? "none" : "block";

                    this.setState({
                        subject: 'Email Subject',
                        body: 'Email Body'
                    });
                });

                subjectInput?.addEventListener("input", (e) => {
                    // Clear any validation message
                    Swal.resetValidationMessage();

                    this.setState({
                        subject: (e.target as HTMLInputElement).value
                    });
                });

                bodyInput?.addEventListener("input", (e) => {
                    // Clear any validation message
                    Swal.resetValidationMessage();

                    this.setState({
                        body: (e.target as HTMLTextAreaElement).value
                    });
                });
            },

            preConfirm: () => {

                const sendInstruction = (
                    document.getElementById("sendInstruction") as HTMLInputElement
                )?.checked;
                // Validation occurs only Send Email Instructions field is unchecked
                if (!sendInstruction && (!this.state.subject || !this.state.body)) {
                    Swal.showValidationMessage(
                        "Subject and Body are required"
                    );
                    return false;
                }

                return true;
            },
        });

        if (result.isConfirmed) {

            const payload = {
                userIds: userIds,
                emailSubject: this.state.subject,
                emailBody: this.state.body,
                emailKwongInstruction: this.state.sendInstruction,
            };

            ProfileServices.sendCustomEmail(payload, this.state.accessToken).then(r => {
                if (r.ok) {
                    r.json().then(response => {
                        ShowAlert("Success", "Email sent successfully", "success").then(r => {
                            this.getAllKwongClaims();
                        });
                    });
                }
            });

            this.setState({
                sendInstruction: false,
                subject: "",
                body: ""
            });
        }

        // Clear the values when user close the popup
        if (result.isDismissed) {
            this.setState({
                sendInstruction: false,
                subject: "",
                body: ""
            });
        }
    };


    public render() {

        const ExpandedComponent = ({ data }: { data: IAuthorizedUser }) => (
            <div style={{ padding: '10px', background: '#f9f9f9' }}>
                <PaymentTable claims={data.claims ? data.claims : []} accessToken={this.state.accessToken} refreshCallBack={this.getAllKwongClaims} />
            </div>
        );
        return (
            <div className='body-sub-contianer table-container'>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mb: 3,
                    }}
                >
                    {/* Title */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 600,
                            color: "text.primary",
                        }}
                    >
                        Kwong Claim Management
                    </Typography>
                    <Typography component="p">
                        Track and manage taxpayer claims and statuses
                    </Typography>
                    {/* Filters Row */}
                    <Box sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        mt: 2,
                        backgroundColor: "#FFF",
                        padding: 2,
                        boxShadow: '0 4px 6px -6px',
                        borderRadius: '10px'
                    }}>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "end",
                                justifyContent: "space-between",
                            }}
                        >
                            {/* Filters */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 2,
                                    alignItems: "end",
                                    '@media (min-width:768px) and (max-width:1024px)': {
                                        mb: 2,
                                    },
                                }}
                            >
                                <FilterAltOutlinedIcon sx={{
                                    fontSize: 30,
                                    opacity: '0.6'
                                }}
                                />
                                <FormControl size="small" sx={{ minWidth: 180 }}>
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        value={this.state.claimStatus}
                                        label="Status"
                                        // onChange={(e) => this.setState({claimStatus: e.target.value})}
                                        onChange={(e) =>
                                            this.setState(
                                                {
                                                    claimStatus: e.target.value,
                                                },
                                                () => {
                                                    this.getAllKwongClaims();
                                                }
                                            )
                                        }
                                    >
                                        <MenuItem value="all">All</MenuItem>
                                        <MenuItem value="completed">Completed</MenuItem>
                                        <MenuItem value="signaturePending">8821 Signature Pending</MenuItem>
                                        <MenuItem value="readyForSubmission">Ready for IRS Submission</MenuItem>
                                        <MenuItem value="submittedToIrs">Submitted to IRS</MenuItem>
                                        <MenuItem value="idvPending">IDV Pending</MenuItem>
                                        <MenuItem value="irsApproved">IRS Approved</MenuItem>
                                        <MenuItem value="late">Late</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl size="small" sx={{ minWidth: 180 }}>
                                    <InputLabel>Review Required</InputLabel>
                                    <Select
                                        value={this.state.reviewReq}
                                        label="Review Required"
                                        // onChange={(e) => this.setState({reviewReq: e.target.value})}
                                        onChange={(e) =>
                                            this.setState(
                                                {
                                                    reviewReq: e.target.value,
                                                },
                                                () => {
                                                    this.getAllKwongClaims();
                                                }
                                            )
                                        }
                                    >
                                        <MenuItem value="all">All</MenuItem>
                                        <MenuItem value="yes">Yes</MenuItem>
                                        <MenuItem value="no">No</MenuItem>
                                        <MenuItem value="pending">Pending</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControlLabel
                                    control={
                                        <Checkbox sx={{
                                            '&:hover': {
                                                backgroundColor: 'transparent',
                                            }
                                        }}
                                            checked={this.state.isManualUpload}
                                            onChange={(e) =>
                                                this.setState(
                                                    {
                                                        isManualUpload: e.target.checked,
                                                    },
                                                    () => {
                                                        this.getAllKwongClaims();
                                                    }
                                                )
                                            }
                                        />
                                    }
                                    label="Imported Users"
                                />

                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "end",
                                ml: "auto",
                            }}
                        >
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: '#8EB850', color: '#FFF', textTransform: 'capitalize',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#8EB850',
                                    }
                                }}
                                onClick={() => this.handleClaimXLSXDownload()}
                                startIcon={<FileDownloadIcon />}
                                fullWidth={window.innerWidth < 600}
                            >
                            Download Claim Details
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => this.handleEmailReminder()}
                                disabled={this.state.selectedRows.length === 0}
                                sx={{
                                    backgroundColor: '#2196F3', color: '#FFF', textTransform: 'capitalize',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#2196F3',
                                    },
                                }}
                                startIcon={<EmailOutlinedIcon />}
                                fullWidth={window.innerWidth < 600}
                            >
                                Email Reminders
                            </Button>

                            {/* <Button
                                variant="contained"
                                sx={{ backgroundColor: '#8EB850', color: '#FFF'}}
                                onClick={() => this.handleDownloadForm843()}
                            >
                            Download 843
                            </Button> */}

                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#9810fa', color: '#FFF', textTransform: 'capitalize',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#9810fa',
                                    },
                                }}
                                disabled={this.state.selectedRows.length === 0}
                                onClick={() => this.handleDownloadTranscript()}
                                startIcon={<DescriptionOutlinedIcon />}
                                fullWidth={window.innerWidth < 600}
                            >
                                Download Transcript
                            </Button>
                        </Box>
                    </Box>
                </Box>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    // title='Kwong Claim Details'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.subList}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}

                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getAllKwongClaims();
                        })
                    }}
                    expandableRows
                    expandedComponent={ExpandedComponent}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                    // conditionalRowStyles={this.conditionalRowStyles}
                    selectableRows
                    // onSelectedRowsChange={(state) => {
                    //     console.log(state.selectedRows);
                    // }}
                    onSelectedRowsChange={(selectedRow: any) => {
                        this.setState({
                            selectedRows: selectedRow.selectedRows
                        });
                    }}
                    customStyles={customStyles}
                    clearSelectedRows={this.state.clearSelectedRows}
                />
            </div>
        )
    }

}
export default KwongClaimManagement;
